import { ApiType } from "@gymflow/common";
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from "@tanstack/react-query";

import { kisiQueryKeys } from "./kisiQueryKeys";

export function useMutationKisiUpdate(
  {
    api,
  }: {
    api: ApiType;
  },
  mutationOpts?: UseMutationOptions<
    void,
    unknown,
    Parameters<ApiType["kisiApi"]["modify"]>[0]
  >,
) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (params: Parameters<ApiType["kisiApi"]["modify"]>[0]) => {
      await api.kisiApi.modify(params);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: kisiQueryKeys.groupMappings(),
      });
    },
    ...mutationOpts,
  });
}
